<template>
  <div class="flex flex-row">
    <TabGroup vertical>
      <TabList class="flex flex-col">
        <tab-item
          v-for="(item, index) in tabs"
          :key="index"
          :color="color"
          :required="item.required"
          :status="item.status"
        >
          <span class="text-lg font-bold">予算</span>
          <span class="text-sm font-bold">詳細</span>
        </tab-item>
      </TabList>
      <TabPanels
        class="ml-3 w-full"
        style="max-height: 510px; height: 410px; overflow-y: scroll"
      >
        <slot name="tabContent" style="overflow: hidden;"></slot>
      </TabPanels>
    </TabGroup>
  </div>
</template>

<script>
import { TabList, TabGroup, TabPanels } from '@headlessui/vue'
import BudgetFormNavigationItem from '@/components/layout/budgets/BudgetFormNavigationItem'
import { useBudgetFormTabs } from '@/services/useBudgetForm'

export default {
  name: 'BudgetFormNavigation',

  components: {
    TabGroup,
    'tab-item': BudgetFormNavigationItem,
    TabList,
    TabPanels,
  },

  props: {
    color: String,
  },

  setup() {
    const { tabs } = useBudgetFormTabs()
    return { tabs }
  },
}
</script>
